import { AuthProvider } from '../../features/auth/hooks/useAuth.tsx';
import { InactivityLogout } from '../../features/auth/components/InactivityLogout.tsx';
import { Outlet, Route, Routes } from 'react-router-dom';
import FeatureProvider from '../../common/providers/FeatureProvider.tsx';
import { ProtectRoute } from './ProtectRoute.tsx';
import DashboardView from '../../features/dashboard/DashboardView.tsx';
import { NavigationRoutes } from './routes.ts';
import { LoginView } from '../../features/auth/LoginView.tsx';
import LayoutComponent from '../layout/LayoutComponent.tsx';
import ThemePage from '../../features/development/ThemePage.tsx';
import TransactionNavigation from '../../features/transaction/TransactionOverview.tsx';
import ChainedTransaction from '../../features/transaction/ChainedTransaction.tsx';
import Withdrawal from '../../features/transaction/Withdrawal.tsx';
import Deposit from '../../features/transaction/Deposit.tsx';
import Inventory from '../../features/transaction/Inventory.tsx';
import OidcCallback from '../../features/auth/OidcCallback.tsx';
import DeviationsOverview from '../../features/deviations/DeviationsOverview.tsx';
import UserManagement from '../../features/userManagement/UserManagement.tsx';
import DrugManagement from '../../features/drugManagement/DrugManagement.tsx';
import UserView from '../../features/userManagement/UserView.tsx';
import CreateUser from '../../features/userManagement/CreateUser.tsx';
import DrugView from '../../features/drugManagement/DrugView.tsx';
import CreateDrug from '../../features/drugManagement/CreateDrug.tsx';
import DeviationView from '../../features/deviations/DeviationView.tsx';
import StorageManagement from '../../features/storageManagement/StorageManagement.tsx';
import CreateStorage from '../../features/storageManagement/CreateStorage.tsx';
import StorageView from '../../features/storageManagement/StorageView.tsx';
import DevComponents from '../../features/development/DevComponents.tsx';
import ProfileView from '../../features/profile/ProfileView.tsx';
import UpdateProfile from '../../features/profile/UpdateProfile.tsx';
import UpdatePassword from '../../features/profile/UpdatePassword.tsx';
import ForgottenPassword from '../../features/profile/ForgottenPassword.tsx';
import ResetPassword from '../../features/profile/ResetPassword.tsx';
import MessagePage from '../../features/development/MessagePage.tsx';
import ShiftChangeInventory from '../../features/transaction/ShiftChangeInventory.tsx';
import NotFoundPage from '../../application/layout/NotFoundPage.tsx';
import Tenants from '../../features/superAdmin/tenantsManagement/TenantsOverview.tsx';
import TenantView from '../../features/superAdmin/tenantsManagement/TenantView.tsx';
import CreateTenant from '../../features/superAdmin/tenantsManagement/CreateTenant.tsx';
import UpdateTenant from '../../features/superAdmin/tenantsManagement/UpdateTenant.tsx';
import StorageDrugReport from '../../features/reports/storageDrugReport.tsx';
import Disposed from '../../features/transaction/Disposed.tsx';
import TenantOrganizationsView from '../../features/superAdmin/TenantOrganizations/TenantOrganizationsView.tsx';
import CreateTenantOrganization from '../../features/superAdmin/TenantOrganizations/CreateTenantOrganization.tsx';
import UpdateTenantOrganization from '../../features/superAdmin/TenantOrganizations/UpdateTenantOrganization.tsx';
import { LabelPrintView } from '../../features/labelPrinting/components/LabelPrintView.tsx';
import Support from '../../pages/Support.tsx';
import MessagesPage from '../../features/messages/MessagesPage.tsx';
import CreateMessagePage from '../../features/messages/CreateMessagePage.tsx';
import MessageDetailPage from '../../features/messages/MessageDetailPage.tsx';
import OrganizationSettingsPage from '../../features/settings/OrganizationSettingsPage.tsx';
import FeedbackList from '../../features/feedback/FeedbackList.tsx';
import FeedbackDetail from '../../features/feedback/FeedbackDetail.tsx';

export default function AppRouter() {
    return (
        <AuthProvider>
            <InactivityLogout />
            <FeatureProvider>
                <Routes>
                    <Route
                        path={NavigationRoutes.login}
                        element={<LoginView />}
                    />
                    <Route
                        path={NavigationRoutes.callback}
                        element={<OidcCallback />}
                    />
                    <Route
                        path={NavigationRoutes.dashboard}
                        element={
                            <ProtectRoute>
                                <LayoutComponent child={<DashboardView />} />
                            </ProtectRoute>
                        }
                    />

                    <Route
                        path={NavigationRoutes.support}
                        element={
                            <ProtectRoute>
                                <LayoutComponent child={<Support />} />
                            </ProtectRoute>
                        }
                    />

                    <Route
                        path={NavigationRoutes.feedback}
                        element={
                            <ProtectRoute>
                                <LayoutComponent child={<FeedbackList />} />
                            </ProtectRoute>
                        }
                    />
                    <Route
                        path={NavigationRoutes.feedbackDetail}
                        element={
                            <ProtectRoute>
                                <LayoutComponent child={<FeedbackDetail />} />
                            </ProtectRoute>
                        }
                    />

                    <Route path={NavigationRoutes.profile}>
                        <Route
                            index
                            path={NavigationRoutes.profile}
                            element={
                                <ProtectRoute>
                                    <LayoutComponent child={<ProfileView />} />
                                </ProtectRoute>
                            }
                        />

                        <Route
                            path={NavigationRoutes.updateProfile}
                            element={
                                <ProtectRoute>
                                    <LayoutComponent
                                        child={<UpdateProfile />}
                                    />
                                </ProtectRoute>
                            }
                        />

                        <Route
                            path={NavigationRoutes.updatePassword}
                            element={
                                <ProtectRoute>
                                    <LayoutComponent
                                        child={<UpdatePassword />}
                                    />
                                </ProtectRoute>
                            }
                        />
                    </Route>

                    <Route path={NavigationRoutes.userManagement}>
                        <Route
                            index
                            path={NavigationRoutes.userManagement}
                            element={
                                <ProtectRoute>
                                    <LayoutComponent
                                        child={<UserManagement />}
                                    />
                                </ProtectRoute>
                            }
                        />
                        <Route
                            path={NavigationRoutes.userView + '/:id'}
                            element={
                                <ProtectRoute>
                                    <LayoutComponent child={<UserView />} />
                                </ProtectRoute>
                            }
                        />
                        <Route
                            path={NavigationRoutes.createUser}
                            element={
                                <ProtectRoute>
                                    <LayoutComponent child={<CreateUser />} />
                                </ProtectRoute>
                            }
                        />
                    </Route>
                    <Route path={NavigationRoutes.drugManagement}>
                        <Route
                            index
                            path={NavigationRoutes.drugManagement}
                            element={
                                <ProtectRoute>
                                    <LayoutComponent
                                        child={<DrugManagement />}
                                    />
                                </ProtectRoute>
                            }
                        />
                        <Route
                            path={NavigationRoutes.drugView + '/:id'}
                            element={
                                <ProtectRoute>
                                    <LayoutComponent child={<DrugView />} />
                                </ProtectRoute>
                            }
                        />
                        <Route
                            path={NavigationRoutes.createDrug}
                            element={
                                <ProtectRoute>
                                    <LayoutComponent child={<CreateDrug />} />
                                </ProtectRoute>
                            }
                        />
                    </Route>
                    <Route path={NavigationRoutes.storageManagement}>
                        <Route
                            index
                            path={NavigationRoutes.storageManagement}
                            element={
                                <ProtectRoute>
                                    <LayoutComponent
                                        child={<StorageManagement />}
                                    />
                                </ProtectRoute>
                            }
                        />
                        <Route
                            path={NavigationRoutes.createStorage}
                            element={
                                <ProtectRoute>
                                    <LayoutComponent
                                        child={<CreateStorage />}
                                    />
                                </ProtectRoute>
                            }
                        />
                        <Route
                            path={NavigationRoutes.storageView + '/:id'}
                            element={
                                <ProtectRoute>
                                    <LayoutComponent child={<StorageView />} />
                                </ProtectRoute>
                            }
                        />
                    </Route>
                    <Route path={NavigationRoutes.reports}>
                        <Route
                            index
                            path={NavigationRoutes.reports}
                            element={
                                <ProtectRoute>
                                    <LayoutComponent
                                        child={<StorageDrugReport />}
                                    />
                                </ProtectRoute>
                            }
                        />
                    </Route>
                    <Route
                        path={NavigationRoutes.labelPrinting}
                        element={
                            <ProtectRoute>
                                <LayoutComponent child={<LabelPrintView />} />
                            </ProtectRoute>
                        }
                    />

                    {/* Messages Routes - KEPT THE NESTED VERSION */}
                    <Route path={NavigationRoutes.messages}>
                        <Route
                            index
                            element={
                                <ProtectRoute>
                                    <LayoutComponent child={<MessagesPage />} />
                                </ProtectRoute>
                            }
                        />
                        <Route
                            path="create"
                            element={
                                <ProtectRoute>
                                    <LayoutComponent
                                        child={<CreateMessagePage />}
                                    />
                                </ProtectRoute>
                            }
                        />
                        <Route
                            path=":id"
                            element={
                                <ProtectRoute>
                                    <LayoutComponent
                                        child={<MessageDetailPage />}
                                    />
                                </ProtectRoute>
                            }
                        />
                    </Route>

                    <Route path={NavigationRoutes.deviations}>
                        <Route
                            index
                            path={NavigationRoutes.deviations}
                            element={
                                <ProtectRoute>
                                    <LayoutComponent
                                        child={<DeviationsOverview />}
                                    />
                                </ProtectRoute>
                            }
                        />
                        <Route
                            path={NavigationRoutes.deviationView + '/:id'}
                            element={
                                <ProtectRoute>
                                    <LayoutComponent
                                        child={<DeviationView />}
                                    />
                                </ProtectRoute>
                            }
                        />
                    </Route>
                    <Route path={NavigationRoutes.transaction}>
                        <Route
                            index
                            element={
                                <ProtectRoute>
                                    <LayoutComponent
                                        child={<TransactionNavigation />}
                                    />
                                    <Outlet />
                                </ProtectRoute>
                            }
                        />
                        <Route
                            path={NavigationRoutes.chainedTransaction}
                            element={
                                <ProtectRoute>
                                    <LayoutComponent
                                        child={<ChainedTransaction />}
                                    />
                                </ProtectRoute>
                            }
                        />
                        <Route
                            path={NavigationRoutes.withdrawal}
                            element={
                                <ProtectRoute>
                                    <LayoutComponent child={<Withdrawal />} />
                                </ProtectRoute>
                            }
                        />
                        <Route
                            path={NavigationRoutes.deposit}
                            element={
                                <ProtectRoute>
                                    <LayoutComponent child={<Deposit />} />
                                </ProtectRoute>
                            }
                        />
                        <Route
                            path={NavigationRoutes.disposed}
                            element={
                                <ProtectRoute>
                                    <LayoutComponent child={<Disposed />} />
                                </ProtectRoute>
                            }
                        />
                        <Route
                            path={NavigationRoutes.shiftChangeInventory}
                            element={
                                <ProtectRoute>
                                    <LayoutComponent
                                        child={<ShiftChangeInventory />}
                                    />
                                </ProtectRoute>
                            }
                        />
                        <Route
                            path={NavigationRoutes.crossCheck}
                            element={
                                <ProtectRoute>
                                    <LayoutComponent child={<Inventory />} />
                                </ProtectRoute>
                            }
                        />
                    </Route>

                    <Route path={NavigationRoutes.tenants}>
                        <Route
                            index
                            path={NavigationRoutes.tenants}
                            element={
                                <ProtectRoute>
                                    <LayoutComponent child={<Tenants />} />
                                </ProtectRoute>
                            }
                        />
                        <Route
                            path={NavigationRoutes.tenantView + '/:id'}
                            element={
                                <ProtectRoute>
                                    <LayoutComponent child={<TenantView />} />
                                </ProtectRoute>
                            }
                        />
                        <Route
                            path={NavigationRoutes.createTenant}
                            element={
                                <ProtectRoute>
                                    <LayoutComponent child={<CreateTenant />} />
                                </ProtectRoute>
                            }
                        />
                        <Route
                            path={NavigationRoutes.afterCreateTenant + '/:id'}
                            element={
                                <ProtectRoute>
                                    <LayoutComponent child={<UpdateTenant />} />
                                </ProtectRoute>
                            }
                        />
                        <Route
                            path={NavigationRoutes.updateTenant + '/:id'}
                            element={
                                <ProtectRoute>
                                    <LayoutComponent child={<UpdateTenant />} />
                                </ProtectRoute>
                            }
                        />
                    </Route>

                    <Route
                        path={NavigationRoutes.tenantOrganizations}
                        element={
                            <ProtectRoute>
                                <LayoutComponent
                                    child={<TenantOrganizationsView />}
                                />
                            </ProtectRoute>
                        }
                    />

                    <Route
                        path={NavigationRoutes.createTenantOrganizations}
                        element={
                            <ProtectRoute>
                                <LayoutComponent
                                    child={<CreateTenantOrganization />}
                                />
                            </ProtectRoute>
                        }
                    />
                    <Route
                        path={NavigationRoutes.updateTenantOrganizations}
                        element={
                            <ProtectRoute>
                                <LayoutComponent
                                    child={<UpdateTenantOrganization />}
                                />
                            </ProtectRoute>
                        }
                    />

                    <Route
                        path={NavigationRoutes.organizationSettings}
                        element={
                            <ProtectRoute>
                                <LayoutComponent
                                    child={<OrganizationSettingsPage />}
                                />
                            </ProtectRoute>
                        }
                    />

                    <Route
                        path={NavigationRoutes.devMessage}
                        element={
                            <ProtectRoute>
                                <LayoutComponent child={<MessagePage />} />
                            </ProtectRoute>
                        }
                    />
                    <Route
                        path={NavigationRoutes.devTheme}
                        element={
                            <ProtectRoute>
                                <LayoutComponent child={<ThemePage />} />
                            </ProtectRoute>
                        }
                    />
                    <Route
                        path={NavigationRoutes.devComponents}
                        element={
                            <ProtectRoute>
                                <LayoutComponent child={<DevComponents />} />
                            </ProtectRoute>
                        }
                    />

                    <Route
                        path={NavigationRoutes.forgottenPassword}
                        element={<ForgottenPassword />}
                    />
                    <Route
                        path={NavigationRoutes.resetPassword}
                        element={<ResetPassword />}
                    />
                    <Route path="*" element={<NotFoundPage />} />
                </Routes>
            </FeatureProvider>
        </AuthProvider>
    );
}
